export default "__VITE_ASSET__BdOFyniz__"